import React from 'react';
import Name from './components/name';
// import Profile from './components/profile';
import AboutMe from './components/about-me';
import Education from './components/education';
import Experiences from './components/experiences';
import Contact from './components/contact';
import Project from './components/project';
import MyProjects from './components/my-projects';
import Skill from './components/skill';
import Background from './components/background';
import {
  Container,
  ChakraProvider,
  Grid,
  IconButton,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
  ModalHeader,
  Image,
  Flex,
  Link,
  Box,
} from '@chakra-ui/react';
import { motion, useScroll, useSpring } from 'framer-motion';
import theme from './theme';
import './components/styles/app.css';
import { BsQrCodeScan } from 'react-icons/bs';
// import './components/styles/verticalTimeline.css';
const qrcode = `${process.env.PUBLIC_URL}/qrcode.svg`;

export default function App() {
  const variants = {
    hidden: { opacity: 0, x: 0, y: 20 },
    enter: { opacity: 1, x: 0, y: 0 },
    exit: { opacity: 0, x: -0, y: 20 },
  };
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001,
  });
  const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <>
      <ChakraProvider theme={theme}>
        <Background />
        <Grid className="qrcode-bar">
          <IconButton
            variant="ghost"
            justifySelf="flex-end"
            onClick={onOpen}
            aria-label="Show portfolio QR code"
            color="brand.400"
            _hover={{ bg: 'rgba(255, 187, 86, 0.1)', color: 'brand.300' }}
          >
            <BsQrCodeScan />
          </IconButton>
        </Grid>
        <Modal onClose={onClose} isOpen={isOpen} isCentered>
          <ModalOverlay />
          <ModalContent maxW="min(92vw, 400px)">
            <ModalHeader pb={4}>
              <Box className="eyebrow">scan to visit</Box>
            </ModalHeader>
            <ModalCloseButton />
            <ModalBody pb={7}>
              <Box className="qr-frame">
                <Image src={qrcode} alt="QR code linking to ichamp.net" />
              </Box>
              <Flex className="qr-caption" align="center" justify="center">
                <Link className="qr-link" href="https://ichamp.net" isExternal>
                  ichamp.net
                </Link>
              </Flex>
            </ModalBody>
            {/* <ModalFooter>
              <Button onClick={onClose}>Close</Button>
            </ModalFooter> */}
          </ModalContent>
        </Modal>
        <motion.div
          initial="hidden"
          animate="enter"
          exit="exit"
          variants={variants}
          transition={{ duration: 0.6, type: 'easeInOut' }}
          className="site-content"
        >
          <Container className="area">
            <motion.div className="progress-bar" style={{ scaleX }} />
            <Name />
            {/* <Profile /> */}
            <AboutMe />
            <Education />
            <Experiences />
            <Project />
            <MyProjects />
            <Skill />
            <Contact />
          </Container>
        </motion.div>
      </ChakraProvider>
    </>
  );
}
